module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msgChild2),
      expression: "msgChild2"
    }],
    attrs: {
      "placeholder": "modifiez-moi"
    },
    domProps: {
      "value": (_vm.msgChild2)
    },
    on: {
      "keyup": _vm.keyUpEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msgChild2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Message ("), _c('strong', [_vm._v("child1")]), _vm._v(") : " + _vm._s(_vm.msgChild1))]), _vm._v(" "), _c('p', [_vm._v("Message ("), _c('strong', [_vm._v("child2")]), _vm._v(") : " + _vm._s(_vm.msgChild2))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4633ad55","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communicate-child2.vue
// module id = 93
// module chunks = 0